import React, { useState } from 'react'
import BreadcrumbHeader from '../../layout/BreadcrumbsHeader'
import { useTheme } from '@emotion/react'
import ThemeBGWrapper from '../../ui-components/ThemeBGWrapper'
import { B300 } from '../../ui-components/CustomButton'
import { Add, Code, ContentCopyOutlined, FileCopy, Link as LinkIcon, OpenInNew } from '@mui/icons-material'
import { Box, Button, Card, CardContent, CardHeader, CircularProgress, Divider, Grid, IconButton, LinearProgress, Menu, MenuItem, Tooltip, Typography, useMediaQuery } from '@mui/material'
import fundingRoundsBackground from "../../assets/rounds_icons/funding_rounds_background.webp"
import { FetchAllRounds } from '../../api/round'
import { ReactComponent as SecurityIcon } from "../../assets/rounds_icons/security_icon.svg"
import { ReactComponent as ViewIcon } from "../../assets/rounds_icons/view_icon.svg"
import { ReactComponent as MoreIcon } from "../../assets/rounds_icons/more_icon.svg"
import { useNavigate } from 'react-router-dom'
import rocket_rounds_image from "../../assets/rounds_icons/rocket_rounds_image.png"
import PerfectScrollbar from "react-perfect-scrollbar"
import moment from 'moment'
import { containerRef, handleCopyClick, handleDateValues, navigateToDomain } from '../../utils'
import { FetchAllAvatars, FetchProfileDetails } from '../../api'
import { TabContext, TabPanel } from '@mui/lab'
import CustomTabs from '../../ui-components/CustomTabs'
import { makeStyles } from '@mui/styles'
import PersonalDetails from './PersonalDetails'
import ProfileSkeleton from './ProfileSkeleton'
import NeedHelpButton from 'ui-components/NeedHelpButton'
import Cookies from 'js-cookie'

const useStyles = makeStyles((theme) => ({
  scrollTabs: {
    '& > .Mui-disabled.MuiTabs-scrollButtons': {
      display: 'none',
      transition: 'all 1s ease'
    }
  }
}));

const Profile = () => {
  const theme = useTheme()
  const isNotLargeScreen = useMediaQuery(theme.breakpoints.down('md'));
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const classes = useStyles();
  const navigate = useNavigate()
  let [investor_id, setInvestorID] = React.useState(Cookies.get("X-INV-ID") || null);
  const { data: userData, isLoading: isUserDataLoading } = FetchProfileDetails({ investor_id });
  // const { data: avatarList, isRefetching: isRefetchingAvatarList, isLoading: isLoadingAvatarList, refetch: refetchAvatarList } = FetchAllAvatars()

  let tabValue = new URLSearchParams(window.location.search).get("page");
  // console.log("tabl",tabValue)

  const [value, setValue] = useState(tabValue || "personal_details");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const roundTabs = [
    {
      label: "Personal Details",
      // icon: RoundDetailsIcon,
      value: "personal_details",
    },
    // {
    //   label: "Sectors",
    //   // icon: RoundInvestorsIcon,
    //   value: "sectors",
    // },
    // {
    //   label: "Stages",
    //   // icon: RoundDocumentsIcon,
    //   value: "stages"
    // }
  ]

  const [copied, setCopied] = React.useState(false);
  const [copiedApplyLink, setCopiedApplyLink] = React.useState(false);
  const [copiedEmbedCode, setCopiedEmbedCode] = React.useState(false);
  const [isLoading, setLoading] = React.useState(false);

  const applyFormLink = userData?.data?.slug ? navigateToDomain("investor", `${userData.data.slug}/apply`) : '';
  const embedCode = applyFormLink ? `<iframe src="${applyFormLink}" width="100%" height="700" frameborder="0" title="Startup Apply Form"></iframe>` : '';

  return (
    <ThemeBGWrapper>
      <BreadcrumbHeader title={() => <Box display={"flex"} alignItems={"center"}>
        Profile
        <Tooltip title={copied ? "Copied to Clipboard" : "Copy Invite URL"}>
          <IconButton sx={{ marginLeft: "0.5rem" }} onClick={() =>
            userData?.data?.invite_link && handleCopyClick(userData?.data?.invite_link, copied, setCopied)}>
            {copied ? (
              <FileCopy sx={{ height: 25 }} />
            ) : (
              <ContentCopyOutlined sx={{ height: 25 }} />
            )}
          </IconButton>
        </Tooltip>
        <Tooltip title="Open Profile URL">
          <IconButton
            onClick={() => userData?.data?.backrr_base_url && window.open(userData?.data?.backrr_base_url, '_blank')}
          >
            <OpenInNew sx={{ height: 25 }} />
          </IconButton>
        </Tooltip>
        <Tooltip title={copiedApplyLink ? "Copied to Clipboard" : "Copy Apply Form Link"}>
          <IconButton sx={{ marginLeft: "0.25rem" }} onClick={() => applyFormLink && handleCopyClick(applyFormLink, copiedApplyLink, setCopiedApplyLink)}>
            <LinkIcon sx={{ height: 25 }} />
          </IconButton>
        </Tooltip>
        <Tooltip title={copiedEmbedCode ? "Copied to Clipboard" : "Copy Embed Code"}>
          <IconButton onClick={() => embedCode && handleCopyClick(embedCode, copiedEmbedCode, setCopiedEmbedCode)}>
            <Code sx={{ height: 25 }} />
          </IconButton>
        </Tooltip>
      </Box>} breadcrumbTitle='Profile' customBackgroundColor={theme.palette.customColors.indigo25} Actions={() => <NeedHelpButton />} />
      {
        isUserDataLoading || isLoading ?
          <Grid item xs={12} sx={{ width: '100%', paddingInline: isSmallScreen ? "1rem" : "2rem", paddingBlock: "1rem" }}>
            <ProfileSkeleton />
          </Grid>
          :
          <>
            {userData && userData?.data &&
              <Grid xs={12} container bgcolor={""}>
                <Box sx={{ width: '100%', typography: 'body1' }}>
                  <TabContext value={value}>
                    {/* <Box px={isSmallScreen ? "1rem" : "2rem"} bgcolor={"#fff"}>
                      <CustomTabs data={roundTabs} value={value} isSmallScreen={isSmallScreen} className={classes} handleChange={handleChange} key={"Tabs Tabs"} />
                    </Box> */}
                    <TabPanel value="personal_details" sx={{ paddingInline: 0, paddingBlock: "1rem" }}>
                      <PerfectScrollbar containerRef={containerRef} style={{ height: "calc(100dvh - 6.25rem)", paddingInline: isSmallScreen ? "1rem" : "2rem" }}>
                        <PersonalDetails data={userData?.data} avatarList={[]} setLoading={setLoading} />
                        {/* {applyFormLink && (
                          <Box mt={3} mb={2} p={2.5} borderRadius="8px" border={`1px solid ${theme.palette.divider}`} bgcolor={theme.palette.customColors.whiteBG}>
                            <Typography variant="h6" fontWeight={700} mb={0.5} color={theme.palette.customColors.g300}>
                              Onboard Startups with Your White-Labeled Form
                            </Typography>
                            <Typography variant="body2" color="text.secondary" mb={2}>
                              Share a branded apply form with startups. They submit their details directly into your deal flow.
                            </Typography>
                            <Box display="flex" flexWrap="wrap" gap={1.5}>
                              <Button
                                variant="outlined"
                                startIcon={<OpenInNew />}
                                onClick={() => window.open(applyFormLink, '_blank')}
                                sx={{ textTransform: 'none' }}
                              >
                                View White-Labeled Form
                              </Button>
                              <Button
                                variant="outlined"
                                startIcon={copiedApplyLink ? <FileCopy /> : <LinkIcon />}
                                onClick={() => handleCopyClick(applyFormLink, copiedApplyLink, setCopiedApplyLink)}
                                sx={{ textTransform: 'none' }}
                              >
                                {copiedApplyLink ? 'Copied!' : 'Copy Apply Form Link'}
                              </Button>
                              <Button
                                variant="outlined"
                                startIcon={copiedEmbedCode ? <FileCopy /> : <Code />}
                                onClick={() => handleCopyClick(embedCode, copiedEmbedCode, setCopiedEmbedCode)}
                                sx={{ textTransform: 'none' }}
                              >
                                {copiedEmbedCode ? 'Copied!' : 'Copy Embed Code'}
                              </Button>
                            </Box>
                          </Box>
                        )} */}
                      </PerfectScrollbar>
                    </TabPanel>
                    {/* <TabPanel value="sectors" sx={{ paddingInline: 0, paddingTop: '0.5rem' }}>
                      <PerfectScrollbar style={{ height: '100%', maxHeight: "calc(100vh - 180px)", paddingBottom: '0.5rem' }}>
                        <RoundInvestors currency={roundDetails?.currency || ''} />
                      </PerfectScrollbar>
                    </TabPanel>
                    <TabPanel value="stages" sx={{ paddingInline: isSmallScreen ? "1rem" : "2rem" }}>
                      <PerfectScrollbar style={{ height: "calc(100vh - 250px)" }}>
                        <RoundDocuments data={roundDetails?.documents} />
                      </PerfectScrollbar>
                    </TabPanel> */}
                  </TabContext>
                </Box>
              </Grid>}
          </>}
    </ThemeBGWrapper>
  )
}

export default Profile